/* Lierro theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var format = window.theme.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return Math.round(value).toLocaleString('en-US');
        case 'amount_with_comma_separator': return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toLocaleString('de-DE');
        case 'amount_with_space_separator': return value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\u202f/g, ' ');
        case 'amount_no_decimals_with_space_separator': return Math.round(value).toLocaleString('fr-FR').replace(/\u202f/g, ' ');
        case 'amount_with_apostrophe_separator': return value.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        default: return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    });
  }

  /* ---------- Drawers & modals ---------- */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null;

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('is-locked');
    openDrawerEl = el;
    var focusable = el.querySelector('input[type="search"], button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }

  function closeDrawer() {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('is-locked');
    openDrawerEl = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-open'));
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) { closeDrawer(); return; }
    if (e.target.classList && e.target.classList.contains('modal')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeLightbox(); }
  });

  /* ---------- Announcement rotator ---------- */
  /* ---------- Black Friday schedule (pages may be cached, so re-check in the browser) ---------- */
  function bfState() {
    var root = document.documentElement;
    var start = parseInt(root.dataset.bfStart, 10), end = parseInt(root.dataset.bfEnd, 10);
    if (!start) return 'off';
    var now = Date.now() / 1000;
    // no end date set = the offer keeps running until it is switched off in Theme settings
    return now < start ? 'before' : (!end || now < end ? 'live' : 'after');
  }
  function applyBf() {
    var state = bfState();
    document.documentElement.classList.toggle('is-bf', state === 'live');
    $$('[data-bf]').forEach(function (el) {
      var w = el.getAttribute('data-bf');
      el.hidden = (w === 'live' && state !== 'live') || (w === 'before' && state !== 'before') || (w === 'not_live' && state === 'live');
    });
    return state;
  }
  var bfNow = applyBf();
  // flip automatically if the page stays open across the start or end time
  setInterval(function () { var s = bfState(); if (s !== bfNow) { bfNow = applyBf(); } }, 30000);

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tickCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var left = Math.max(0, parseInt(el.dataset.countdown, 10) - Math.floor(Date.now() / 1000));
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
      var set = function (k, v) { var b = el.querySelector('[data-cd="' + k + '"]'); if (b) b.textContent = v; };
      set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(sec));
    });
  }
  tickCountdowns();
  setInterval(tickCountdowns, 1000);

  /* ---------- Announcement rotator (skips hidden messages) ---------- */
  $$('[data-rotator]').forEach(function (track) {
    var i = -1;
    function next() {
      var msgs = $$('.announcement__msg', track).filter(function (m) { return !m.hidden; });
      $$('.announcement__msg', track).forEach(function (m) { m.classList.remove('is-active'); });
      if (!msgs.length) return;
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    next();
    setInterval(next, parseInt(track.dataset.interval, 10) || 4000);
  });

  /* ---------- Slideshow ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = $('[data-slider-track]', slider);
    var dots = $$('[data-slider-dots] button', slider);
    var count = track.children.length;
    if (count < 2) return;
    var index = 0, timer;
    function go(n) {
      index = (n + count) % count;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    }
    function start() {
      var ms = parseInt(slider.dataset.autoplay, 10);
      if (ms > 0) { clearInterval(timer); timer = setInterval(function () { go(index + 1); }, ms); }
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      startX = null;
    });
    start();
  });

  /* ---------- Carousels ---------- */
  function initCarousels(ctx) {
    $$('[data-carousel]', ctx).forEach(function (c) {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      var track = $('[data-carousel-track]', c);
      var prev = $('[data-carousel-prev]', c);
      var next = $('[data-carousel-next]', c);
      if (!track) return;
      function step() { var item = track.children[0]; return item ? item.getBoundingClientRect().width + 20 : 300; }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }
  initCarousels(document);

  /* ---------- Cart ---------- */
  // The drawer lives in a section group, so it must be re-rendered by its full id (keeps its settings)
  var drawerEl = $('[data-cart-drawer]');
  var drawerId = drawerEl ? drawerEl.dataset.sectionId : 'cart-drawer';
  var cartSections = [drawerId];

  function refreshCart(sectionsHtml) {
    if (sectionsHtml && sectionsHtml[drawerId]) {
      var doc = new DOMParser().parseFromString(sectionsHtml[drawerId], 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');
      var current = $('[data-cart-drawer]');
      if (fresh && current) {
        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) { current.classList.add('is-open'); openDrawerEl = current; }
      }
    }
    fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  function addToCart(items, button) {
    if (button) button.classList.add('is-loading');
    return fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: cartSections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
        refreshCart(res.data.sections);
        var cartLink = $('.header__cart');
        if (cartLink && cartLink.hasAttribute('data-open')) openDrawer('cart-drawer');
        else window.location.href = window.theme.routes.cart;
        return res.data;
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    var list = $$('[data-cart-items]');
    list.forEach(function (l) { l.classList.add('is-loading'); });
    var isCartPage = !!$('[data-cart-page]');
    return fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: cartSections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (isCartPage) { window.location.reload(); return; }
        refreshCart(data.sections);
      })
      .finally(function () { list.forEach(function (l) { l.classList.remove('is-loading'); }); });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-change]');
    var remove = e.target.closest('[data-remove]');
    var quick = e.target.closest('[data-quick-add]');
    if (step || remove) {
      var item = e.target.closest('[data-line]');
      var line = parseInt(item.dataset.line, 10);
      var input = $('[data-line-qty]', item);
      var qty = remove ? 0 : Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.qtyChange, 10));
      changeLine(line, qty);
    }
    if (quick) {
      var row = quick.closest('[data-upsell]');
      var picker = row ? $('[data-upsell-variant]', row) : null;
      var variantId = parseInt(picker ? picker.value : quick.dataset.quickAdd, 10);
      addToCart([{ id: variantId, quantity: 1 }], quick).catch(function (err) { alert(err.message); });
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line-qty]')) {
      var item = e.target.closest('[data-line]');
      changeLine(parseInt(item.dataset.line, 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var form = $('form.product-form', section);
    var variantsEl = $('[data-variants]', section);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-button]', form) : null;
    var addText = addBtn ? $('[data-add-text]', addBtn) : null;
    var qtyInput = $('[data-qty-input]', section);
    var errorEl = $('[data-form-error]', section);
    var gallery = $('[data-gallery-track]', section);
    var stickyBar = $('[data-sticky-atc]');
    var stickyAdd = $('[data-sticky-add]');
    var stickyPrice = $('[data-sticky-price]');

    // Gallery
    function showMedia(id) {
      if (!gallery || !id) return;
      var slide = $('[data-media-id="' + id + '"]', gallery);
      if (!slide) return;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }
    $$('[data-thumb]', section).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });
    if (gallery) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        var slide = gallery.children[i];
        if (slide) $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === slide.dataset.mediaId); });
      }, { passive: true });
    }

    // Variants
    function selectedOptions() {
      return $$('fieldset[data-option-index]', section).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function updateAvailability(options) {
      $$('fieldset[data-option-index]', section).forEach(function (fs) {
        var idx = parseInt(fs.dataset.optionIndex, 10);
        $$('input', fs).forEach(function (input) {
          // Available if some in-stock variant has this value and matches the options chosen before it
          var match = variants.some(function (v) {
            if (!v.available || v.options[idx] !== input.value) return false;
            for (var k = 0; k < idx; k++) { if (v.options[k] !== options[k]) return false; }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match);
        });
        var valueEl = $('[data-option-value]', fs);
        if (valueEl) valueEl.textContent = options[idx];
      });
    }
    function updateStock(variant) {
      var stock = $('[data-stock]', section);
      if (!stock) return;
      var text = $('[data-stock-text]', stock);
      var dot = $('.stock__dot', stock);
      var threshold = parseInt(stock.dataset.threshold, 10);
      var low = variant && variant.tracked && variant.qty > 0 && variant.qty <= threshold;
      dot.classList.toggle('stock__dot--low', !!low);
      if (!variant || !variant.available) { text.textContent = window.theme.strings.soldOut; dot.classList.add('stock__dot--low'); }
      else if (low) text.textContent = stock.dataset.lowText.replace('__N__', variant.qty);
      else text.textContent = stock.dataset.inText;
    }
    function updatePrice(variant) {
      var price = $('[data-price]', section);
      if (!price || !variant) return;
      var current = $('[data-price-current]', price);
      var compare = $('[data-price-compare]', price);
      var badge = $('[data-price-badge]', price);
      var onSale = variant.compare_at_price > variant.price;
      current.textContent = formatMoney(variant.price);
      price.classList.toggle('price--sale', onSale);
      compare.hidden = !onSale;
      compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          badge.textContent = badge.textContent.replace(/\d+%/, pct + '%').replace(/[$€£][\d.,]+/, formatMoney(variant.compare_at_price - variant.price));
        }
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      updateOffer(variant);
    }
    function onVariantChange() {
      var options = selectedOptions();
      var variant = variants.find(function (v) { return v.options.every(function (o, k) { return o === options[k]; }); });
      updateAvailability(options);
      updateStock(variant);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = window.theme.strings.unavailable;
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addText.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      updatePrice(variant);
      if (variant.media_id) showMedia(variant.media_id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('fieldset[data-option-index] input', section).forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });
    if (variants.length) updateAvailability(selectedOptions());

    // Quantity
    $$('[data-qty-step]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10));
        syncBundle();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', syncBundle);

    // Bundle tiers set the quantity
    var tiers = $$('[data-bundle-qty]', section);
    function syncBundle() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var active = null;
      tiers.forEach(function (t) { if (q >= parseInt(t.dataset.bundleQty, 10)) active = t; });
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === active); });
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = t.dataset.bundleQty;
        syncBundle();
      });
    });

    // Offer cards (1 / 2 / 3 pairs): the active card has one row per pair, each with its own size (and colour)
    var offer = $('[data-offer]', section);
    var offerCards = offer ? $$('[data-offer-card]', offer) : [];
    var offerDataEl = offer ? $('[data-offer-products]', offer) : null;
    var offerData = offerDataEl ? JSON.parse(offerDataEl.textContent) : {};
    function activeCard() { return offerCards.filter(function (c) { return $('input[type=radio]', c).checked; })[0]; }
    function syncOffer() { offerCards.forEach(function (c) { c.classList.toggle('is-active', $('input[type=radio]', c).checked); }); }
    function updateOffer(variant) {
      offerCards.forEach(function (c) {
        var q = parseInt(c.dataset.qty, 10), off = parseInt(c.dataset.off, 10);
        var total = Math.round(variant.price * q * (100 - off) / 100);
        var compare = Math.max(variant.compare_at_price || 0, variant.price) * q;
        var p = $('[data-offer-price]', c), s = $('[data-offer-compare]', c);
        if (p) p.textContent = formatMoney(total);
        if (s) { s.textContent = formatMoney(compare); s.hidden = compare <= total; }
      });
    }
    function fillSizes(select, productId) {
      var data = offerData[productId];
      if (!data) return;
      var wanted = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
      select.innerHTML = '';
      data.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id; o.textContent = v.title; o.disabled = !v.available;
        if (v.title === wanted && v.available) o.selected = true;
        select.appendChild(o);
      });
      var row = select.closest('[data-offer-row]');
      var thumb = row ? $('[data-offer-thumb]', row) : null;
      if (thumb && data.image) { thumb.src = data.image; thumb.removeAttribute('srcset'); }
    }
    if (offer) {
      offerCards.forEach(function (c) { $('input[type=radio]', c).addEventListener('change', syncOffer); });
      offer.addEventListener('change', function (e) {
        if (e.target.matches('[data-offer-product]')) fillSizes($('[data-offer-size]', e.target.closest('[data-offer-row]')), e.target.value);
        // the first pair's size is the product's selected variant
        if (e.target.matches('[data-offer-size]') && e.target.closest('[data-offer-row]') === $('[data-offer-row]', e.target.closest('[data-offer-card]')) && idInput) idInput.value = e.target.value;
      });
      syncOffer();
    }

    // Add to cart
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var items = [{ id: parseInt(idInput.value, 10), quantity: qty }];
        var card = activeCard();
        if (card) {
          items = [];
          $$('[data-offer-size]', card).forEach(function (sel) {
            var id = parseInt(sel.value, 10);
            var same = items.filter(function (it) { return it.id === id; })[0];
            if (same) same.quantity += 1; else items.push({ id: id, quantity: 1 });
          });
        }
        addToCart(items, addBtn).catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
      });
    }

    // Sticky add to cart
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      stickyBar.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    // Zoom
    $$('[data-zoom]', section).forEach(function (btn) {
      btn.addEventListener('click', function () { openLightbox(btn.dataset.zoom); });
    });
  });

  /* ---------- Reviews ---------- */
  $$('[data-reviews]').forEach(function (box) {
    var form = $('[data-review-form]', box);
    var toggle = $('[data-review-toggle]', box);
    if (toggle && form) toggle.addEventListener('click', function () {
      form.hidden = !form.hidden;
      if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (form && ($('[data-review-success]', form) || $('.form-error', form))) form.hidden = false;
    var more = $('[data-review-more]', box);
    if (more) more.addEventListener('click', function () {
      $$('[data-review][hidden]', box).forEach(function (r) { r.hidden = false; });
      more.hidden = true;
    });
    $$('[data-zoom]', box).forEach(function (btn) {
      btn.addEventListener('click', function () { openLightbox(btn.dataset.zoom); });
    });
  });

  /* ---------- Story (scrolling) ---------- */
  $$('[data-story]').forEach(function (story) {
    var chapters = $$('[data-story-chapter]', story);
    var images = $$('[data-story-img]', story);
    var current = $('[data-story-current]', story);
    var progress = $('[data-story-progress]', story);

    // headings fade in word by word
    $$('[data-story-title]', story).forEach(function (title) {
      var words = title.textContent.trim().split(/\s+/);
      title.innerHTML = words.map(function (w, i) { return '<span class="w" style="--i:' + i + '">' + w.replace(/</g, '&lt;') + '</span>'; }).join(' ');
    });

    function activate(index) {
      chapters.forEach(function (c, i) { c.classList.toggle('is-active', i === index); });
      images.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
      if (current) current.textContent = (index + 1 < 10 ? '0' : '') + (index + 1);
      if (progress) progress.style.width = ((index + 1) / chapters.length * 100) + '%';
    }

    if (!('IntersectionObserver' in window)) {
      $$('[data-story-title]', story).forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); reveal.unobserve(e.target); } });
    }, { threshold: 0.4 });
    $$('[data-story-title]', story).forEach(function (t) { reveal.observe(t); });

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) activate(parseInt(e.target.dataset.storyChapter, 10)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    chapters.forEach(function (c) { spy.observe(c); });
  });

  /* ---------- First order popup ---------- */
  (function () {
    var popup = $('[data-popup]');
    if (!popup) return;
    var KEY = 'lierro-popup-closed';
    function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function read() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function open() {
      if (!popup.hidden) return;
      popup.hidden = false;
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
    }
    function close() {
      popup.classList.remove('is-open');
      setTimeout(function () { popup.hidden = true; }, 300);
      store(String(Date.now()));
    }
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('[data-popup-close]')) close();
    });
    // after signing up (or an error) the page reloads: show the result right away
    if ($('[data-popup-success]', popup) || $('[data-popup-error]', popup)) { open(); store(String(Date.now())); return; }
    var last = parseInt(read(), 10);
    var days = parseInt(popup.dataset.days, 10) || 14;
    if (last && Date.now() - last < days * 864e5 && popup.dataset.test !== 'true') return;
    setTimeout(open, parseInt(popup.dataset.delay, 10) || 15000);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth >= 990) open();
    });
  })();

  /* ---------- Lightbox ---------- */
  var lightbox = $('[data-lightbox]');
  function openLightbox(src) {
    if (!lightbox) return;
    $('[data-lightbox-img]', lightbox).src = src;
    lightbox.hidden = false;
    document.body.classList.add('is-locked');
  }
  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    document.body.classList.remove('is-locked');
  }
  if (lightbox) lightbox.addEventListener('click', closeLightbox);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length && el.querySelector('.carousel')) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCarousels(el); }
        else el.hidden = true;
      });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(window.theme.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results.products) || [];
            if (!products.length) { searchResults.innerHTML = '<p class="muted">No results for “' + q.replace(/</g, '&lt;') + '”.</p>'; return; }
            searchResults.innerHTML = '<div class="predictive__list">' + products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=128" alt="" loading="lazy">' : '';
              return '<a class="predictive__item" href="' + p.url + '">' + img + '<span><span class="card__title">' + p.title + '</span><br><strong>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</strong></span></a>';
            }).join('') + '</div><p><a class="link-arrow" href="/search?type=product&q=' + encodeURIComponent(q) + '">View all results</a></p>';
          });
      }, 250);
    });
  }

  /* ---------- Collection filters ---------- */
  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(filterForm));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      window.location.search = params.toString();
    });
    document.addEventListener('click', function (e) {
      $$('details.filter[open]', filterForm).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }
})();
